import {Middleware} from 'redux';
import {ActionTypes, combineFilters, excludeAction, includeAction} from 'redux-undo';
import {
    BRING_ELEMENT_TO_FRONT,
    SEND_ELEMENT_TO_BACK,
    SET_HIGHLIGHTED_ELEMENT_INDEX,
    SET_IS_SLIDE_MODIFIED_ACTION,
    setIsSlideModifiedAction,
    UPDATE_SCALE,
    UPDATE_SELECTED_SLIDE,
} from '../actions/slide';

export const undoRedoMiddleware: Middleware = (store) => (next) => async (action) => {
    const result = next(action);

    if (action.type === ActionTypes.UNDO || action.type === ActionTypes.REDO) {
        store.dispatch(setIsSlideModifiedAction(true));
    }

    return result;
};

/**
 * Array of action types to be included in the undo/redo functionality.
 * These actions will trigger a state save in the undo history.
 *
 * @type {string[]}
 */
const includeSlideActions: string[] = [BRING_ELEMENT_TO_FRONT, SEND_ELEMENT_TO_BACK, UPDATE_SELECTED_SLIDE];

/**
 * Array of action types to be excluded from the undo/redo functionality.
 * These actions will not trigger a state save in the undo history.
 *
 * @type {string[]}
 */
const excludeSlideActions: string[] = [UPDATE_SCALE, SET_IS_SLIDE_MODIFIED_ACTION, SET_HIGHLIGHTED_ELEMENT_INDEX];

/**
 * Combines the include and exclude filters for slide-related actions.
 * This filter is used to control which actions are tracked by the undo/redo functionality.
 *
 * @type {ReturnType<typeof combineFilters>}
 */
export const combinedSlideFilter: ReturnType<typeof combineFilters> = combineFilters(
    includeAction(includeSlideActions),
    excludeAction(excludeSlideActions)
);
